module.exports = __webpack_public_path__ + "img/flight_takeoff.fd44f350.svg";